export enum ListeningStatus {
  IDLE = 'IDLE',
  LISTENING = 'LISTENING',
  LOADING = 'LOADING',
  END = 'END',
  ERROR = 'ERROR',
  LOADING_ANSWER = 'LOADING_ANSWER',
}

export type ListeningStatusKey = keyof typeof ListeningStatus;

export type SpeechRecognitionResponse = {
  alternatives?: Array<{ transcript: string }>;
  errorMessage?: string;
  isFinal: boolean;
};

export type DialogFlowResult = {
  text: string;
  intent: string;
};
